export const TRANSLATIONS = {
    EN: {
        UBO: {
            PAYMENT: {
                PAGE_TITLE: 'Overview of your order',
                COSTS: 'UBO registration',
                PRODUCT_UBO: 'UBO registration per BV x{amount}',
                PRODUCT_EXTRA: 'Additional UBO x{amount}',
            },
            OVERVIEW: {
                MESSAGE_DESCRIPTION:
                    'If the {entity} needs any information, he or she will contact you and send you a message. You will receive a notification per email. It is not necessary to send the notary a message about the status of the procedure. Automatic notifications are enabled for this.',
            },
        },
    },
    NL: {
        UBO: {
            PAYMENT: {
                PAGE_TITLE: 'Overzicht van uw bestelling',
                COSTS: 'Inschrijving UBO',
                PRODUCT_UBO: 'UBO inschrijving per BV x{amount}',
                PRODUCT_EXTRA: 'Additionele UBO x{amount}',
            },
            OVERVIEW: {
                MESSAGE_DESCRIPTION:
                    'Als de {entity} informatie nodig heeft, neemt hij of zij contact met u op en stuurt u een bericht. Je ontvangt een melding per e-mail. Het is niet nodig om de {entity} een bericht te sturen over de status van de procedure. Hiervoor zijn automatische meldingen ingeschakeld.',
            },
        },
    },
};
